<template>
  <v-pagination
    color="blue-grey"
    v-if="total > limit"
    v-model="currentPage"
    :length="Math.ceil(total / limit)"
    :total-visible="7"
  />
</template>
<script>
const { mapMutations } = require('vuex');
export default {
  data: () => ({
    currentPage: 1
  }),
  props: {
    total: {
      type: Number,
      required: true
    },
    datatype: {
      type: String,
      required: true
    }
  },
  computed: {
    pagination() {
      return this.$store.state.AdminUserStore.pagination.find((item) => item.datatype === this.datatype);
    },
    limit() {
      return this.$store.state.AdminUserStore.pagination.find((item) => item.datatype === this.datatype)?.limit ?? 25;
    },
    offset() {
      return this.$store.state.AdminUserStore.pagination.find((item) => item.datatype === this.datatype)?.offset ?? 0;
    }
  },
  methods: {
    ...mapMutations({
      setPagination: 'AdminUserStore/setPagination'
    }),
    initPagination() {
      if (!this.pagination) {
        this.setPagination({
          datatype: this.datatype,
          limit: this.limit,
          offset: this.offset ?? 0
        });
      } else {
        this.currentPage = (this.offset ?? 0) / this.limit + 1;
      }
    }
  },
  watch: {
    currentPage: {
      handler(currPageNumber) {
        this.setPagination({
          datatype: this.datatype,
          limit: this.limit,
          offset: this.limit * currPageNumber - this.limit ?? 0
        });
        this.$emit('changePage');
      }
    },
    datatype: {
      handler() {
        this.initPagination();
      },
      immediate: true
    },
    offset: {
      handler() {
        this.initPagination();
      }
    }
  }
};
</script>
